module.exports = __webpack_public_path__ + "static/media/filter.6011b0f8.svg";